export const SAVED_FILTER_NAME_MAX_LENGTH = 100;
export const SAVED_FILTER_TYPES = [
  'contracts',
  'deliveries',
  'invoices',
  'invoices-v2',
  'ledger-accounts',
  'scans',
  'suppliers',
  'tax-codes',
] as const;
